import React from "react";
import { Box, Pagination } from "@mui/material";
import { connectPagination } from "react-instantsearch-dom";

type PaginationProps = { currentRefinement: any; nbPages: number; refine: Function; createURL: Function; page?: number };

const CustomPagination = (props: PaginationProps): JSX.Element => {
  const { nbPages, refine, page = 1 } = props;
  const handleChange = (event: React.ChangeEvent<any>, page: number) => refine(page);

  const pages = nbPages;

  return (
    <Box py="2rem">
      <Pagination page={page} count={pages} onChange={handleChange} variant="outlined" />
    </Box>
  );
};

export default connectPagination(CustomPagination);
